<template>
  <div class="input-container">
    <div class="input-group">
      <input
        :type="'text'"
        :value="'*********'"
        :disabled="true"
        autocapitalize="none"/>
      <label class="field-name">{{ fieldText }}</label>
    </div>
    <img class="green-lock" src="../../assets/lock_green.png"/>
  </div>
</template>

<script>

export default {
  name: 'SecretInputField',
  props: ['fieldText'],
};

</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
    .input-container {
      height: 40px;
      margin-bottom: 20px;


      .input-group {
        position: relative;
        width: 100%;
        height: 40px;

        .top-left-label {
          position: absolute;
          top: -13px;
          right: -2px;
          width: 100%;
          text-align: left;
          font-size: 11px;
          color: $riseup_gray_2;
        }

        > input {
          font-size: 20px;
          width: 100%;
          height: 100%;
          padding: 10px 10px 10px 5px;
          display: block;
          border: 1px solid #9b9b9b;
          border-radius: 3px;

          &:disabled {
            color: $riseup_gray_2;
            border: 1px solid $riseup_gray_2;
            background-color: $riseup_gray_0;
          }

          &:disabled ~ .field-name {
            position: relative;
            top: -59px;
            font-size: 12px;
            color: $riseup_gray_2;
          }
        }
      }

      > img {
        position: relative;
        top: -31px;
        left: -220px;

        &.green-lock {
          height: 25px;
          top: -32px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/base-components/card-parts/SecretInputField.vue